import { IconProps } from '.';

const AreaIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        className={customClasses}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.416992 1.66675C0.416992 0.976392 0.976636 0.416748 1.66699 0.416748H13.3337C14.024 0.416748 14.5837 0.976392 14.5837 1.66675V15.4167H28.3337C29.024 15.4167 29.5837 15.9764 29.5837 16.6667V28.3334C29.5837 29.0238 29.024 29.5834 28.3337 29.5834H1.66699C0.976636 29.5834 0.416992 29.0238 0.416992 28.3334V1.66675ZM2.91699 2.91675V8.75008H6.66699V11.2501H2.91699V27.0834H27.0837V17.9167H12.0837V2.91675H2.91699Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66699 17.0835H6.66699V19.5835H1.66699V17.0835Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.417 28.3335V23.3335H12.917V28.3335H10.417Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 28.3335V23.3335H21.25V28.3335H18.75Z"
        fill={color}
      />
    </svg>
  );
};

export default AreaIcon;
